import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Settings } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { PropertyCard } from '../../components/host/PropertyCard';
import { QuickActionCard } from '../../components/host/QuickActionCard';
import { ActivityTimeline } from '../../components/host/ActivityTimeline';
import { AlertCard } from '../../components/host/AlertCard';
// Mock data
const mockProperty = {
  name: 'Via Roma 123, Appartamento 4B',
  imageUrl: 'https://a0.muscache.com/im/pictures/prohost-api/Hosting-1353673811838304349/original/142376af-a8ad-457c-a3af-4b264a5e291c.jpeg?aki_policy=xx_large'
};
const mockActivities = [{
  id: '1',
  type: 'cleaning' as const,
  description: 'Pulizia completata',
  timestamp: 'Oggi 14:30'
}, {
  id: '2',
  type: 'maintenance' as const,
  description: 'Manutenzione risolta',
  timestamp: 'Ieri'
}, {
  id: '3',
  type: 'access' as const,
  description: 'Accesso tablet',
  timestamp: '26 Gen',
  person: 'Mario R.'
}, {
  id: '4',
  type: 'cleaning' as const,
  description: 'Pulizia completata',
  timestamp: '25 Gen'
}, {
  id: '5',
  type: 'access' as const,
  description: 'Accesso tablet',
  timestamp: '24 Gen',
  person: 'Laura B.'
}];
const mockActiveReport = {
  title: '1 segnalazione in corso',
  description: '🔧 Oggetto Rotto - Bagno'
};
export function HostHomePage() {
  const {
    t
  } = useLanguage();
  const navigate = useNavigate();
  // Toggle to demonstrate both states
  const [hasActiveReports, setHasActiveReports] = useState(false);
  const quickActions = [{
    icon: '📸',
    label: t.host.dashboard.quickActions.referencePhotos,
    path: '/host/reference-photos'
  }, {
    icon: '📋',
    label: t.host.dashboard.quickActions.interventionsHistory,
    path: '/host/interventions'
  }, {
    icon: '👥',
    label: t.host.dashboard.quickActions.tabletAccess,
    path: '/host/access-history'
  }];
  const handleQuickAction = (path: string) => {
    navigate(path);
  };
  const handleAlertClick = () => {
    navigate('/host/active-report');
  };
  const handleSettingsClick = () => {
    console.log('Open settings');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-1013">
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 pb-12" data-id="element-1014">
        {/* Header with Greeting */}
        <motion.div className="mb-8" initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} data-id="element-1015">
          <h1 className="text-3xl font-bold text-navy" data-id="element-1016">
            {t.host.dashboard.greeting}
          </h1>
        </motion.div>

        {/* Property Card */}
        <div className="mb-8" data-id="element-1017">
          <PropertyCard name={mockProperty.name} imageUrl={mockProperty.imageUrl} data-id="element-1018" />
        </div>

        {/* Alert Card (conditional) */}
        {hasActiveReports && <div className="mb-8" data-id="element-1019">
            <AlertCard title={mockActiveReport.title} description={mockActiveReport.description} onClick={handleAlertClick} viewDetailsLabel={t.host.dashboard.viewDetails} data-id="element-1020" />
          </div>}

        {/* Quick Actions */}
        <div className="mb-8" data-id="element-1021">
          <motion.h3 className="text-lg font-bold text-navy mb-4" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2
        }} data-id="element-1022">
            {t.host.dashboard.quickActionsTitle}
          </motion.h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1023">
            {quickActions.map((action, index) => <QuickActionCard key={action.path} icon={action.icon} label={action.label} onClick={() => handleQuickAction(action.path)} delay={0.1 + index * 0.1} data-id="element-1024" />)}
          </div>
        </div>

        {/* Activity Timeline */}
        <ActivityTimeline title={t.host.dashboard.recentActivity} activities={mockActivities.map(activity => ({
        ...activity,
        description: activity.type === 'cleaning' ? t.host.dashboard.activities.cleaningCompleted : activity.type === 'maintenance' ? t.host.dashboard.activities.maintenanceResolved : t.host.dashboard.activities.tabletAccess
      }))} data-id="element-1025" />

        {/* Debug toggle for demo purposes - remove in production */}
        <div className="mt-8 p-4 bg-gray-100 rounded-xl" data-id="element-1026">
          <label className="flex items-center gap-3 cursor-pointer" data-id="element-1027">
            <input type="checkbox" checked={hasActiveReports} onChange={e => setHasActiveReports(e.target.checked)} className="w-5 h-5 rounded border-gray-300 text-teal-deep focus:ring-teal-deep" data-id="element-1028" />
            <span className="text-sm text-gray-600" data-id="element-1029">
              Demo: Mostra segnalazione attiva
            </span>
          </label>
        </div>
      </main>
    </div>;
}